/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ShowManagementShowShowResponse } from './ShowManagementShowShowResponse';

export type ShowManagementShowShowResponseApiRespoonse = {
    data?: ShowManagementShowShowResponse;
    status?: ShowManagementShowShowResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ShowManagementShowShowResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

